import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestCadastroUsuarioMaster({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'usuariomaster', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteCadastroUsuarioMaster({ payload }) {
  try {
    const { usua_login, params } = payload;

    yield call(api.delete, `usuariomaster${usua_login}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* desbloquearUsuarioPorTempo({ payload }) {
  try {
    const { usua_login, params } = payload;

    yield call(api.get, `usuariomaster/desbloquearusuariotempo/${usua_login}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success('Usuário Desbloqueado com sucesso !');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { usuarioMasterVO, params } = payload;

    yield call(api.post, 'usuariomaster', usuarioMasterVO);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    // history.push('/usuariomaster');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { usua_login } = payload;

    const { data } = yield call(api.get, `usuariomaster/${usua_login}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { usuarioMasterVO, params } = payload;
    yield call(api.put, 'usuariomaster', usuarioMasterVO);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoalteracao'));
    // history.push('/usuariomaster');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'usuariomaster', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@cadastrousuariomaster/CADASTROUSUARIOMASTER_IN_REQUEST',
    requestCadastroUsuarioMaster
  ),
  takeLatest(
    '@cadastrousuariomaster/DELETE_CADASTROUSUARIOMASTER',
    deleteCadastroUsuarioMaster
  ),
  takeLatest(
    '@cadastrousuariomaster/UNBLOCK_CADASTROUSUARIOMASTER',
    desbloquearUsuarioPorTempo
  ),
  takeLatest(
    '@cadastrousuariomaster/SUCCESS_REMOVE',
    requestCadastroUsuarioMaster
  ),
  takeLatest('@cadastrousuariomaster/STORE_CADASTROUSUARIOMASTER', store),
  takeLatest('@cadastrousuariomaster/FIND_CADASTROUSUARIOMASTER', find),
  takeLatest('@cadastrousuariomaster/UPDATE_CADASTROUSUARIOMASTER', update),
  takeLatest('@cadastrousuariomaster/RECORD_FILTERING', applyedFilters),
]);
